class HeroReviewsSlider extends Theme.Component {
 constructor() {
    super();

    this.defineElements({
      slider: ".hero-reviews-slider",
      previous_button: "button:first-of-type",
      next_button: "button:last-of-type"
    });
    console.log("🧩 Defined elements:", this.elements);

    if (!this.elements.slider) {
      this.elements.slider = this.querySelector(".hero-reviews-slider");
      console.log("🧩 Fallback slider found:", this.elements.slider);
    }

    this.elements.slider_items = this.querySelectorAll(".hero-reviews-slider-item");
  }

  connectedCallback() {
    console.log("✅ HeroReviewsSlider connected");
     requestAnimationFrame(() => this.observer());
  }

  observer() {
    console.log("👀 Observer initialized");
    const observer = new ResizeObserver((entries) => {
      entries.forEach(entry => {
        console.log("📏 Resize width:", entry.contentRect.width);
        const width = entry.contentRect.width;

        if (width <= 0) {
          console.log("⛔ Ignoring zero width resize");
          return;
        }

        if (this.slider) {
          this.teardown();
        }

        this.setup(width);
      });
    });

    observer.observe(this.elements.slider);
  }

  setup(width) {
    console.log("⚙️ Setup started with width:", width);
    let options = {
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: false,
      groupCells: 1
    };

    this.slider = new Flickity(this.elements.slider, options);
    console.log("✨ Flickity initialized:", this.slider);

    this.elements.slider_items.forEach((element) => {
      element.style.height = "100%";
    });
  }

  teardown() {
    console.log("🧹 Teardown called");
    this.slider.destroy();

    this.elements.slider_items.forEach((element) => {
      element.style.height = "auto";
    });
  }

  next() {
    console.log("➡️ Next slide");
    this.slider.next();
  }

  previous() {
    console.log("⬅️ Previous slide");
    this.slider.previous();
  }
}

customElements.define("component-hero-reviews-slider", HeroReviewsSlider);